module.exports = __webpack_public_path__ + "static/img/4974_phase_function_Paper_Points.e1163d0.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/raw_data/images/4974_phase_function_Paper_Points.png
// module id = AoJz
// module chunks = 0